import type { ICategory } from "app/common/services/categoryService.types";
import categoryService from "app/common/services/categoryService";
import { UserCustomCategoryService } from "app/services/category/userCustomCategoryService";

export const getCustomIndustryId = (categoryId: string) => {
    if (categoryId[0] === "*") {
        return categoryId.substring(1);
    }
    return undefined;
};

export const getCategoryObject = (categoryId: string): ICategory | undefined => {
    const isCustomCategory = UserCustomCategoryService.isCustomCategory(categoryId);
    if (isCustomCategory) {
        return UserCustomCategoryService.getCategoryByForUrl(categoryId);
    }
    return categoryService.getCategory(categoryId);
};
